import React, { useEffect, useState } from 'react';

const ResponsiveColorWidget = () => {
  const [bgColor, setBgColor] = useState(getColor(window.innerWidth));

  function getColor(width) {
    if (width < 640) return 'bg-red-400';       // Mobile
    if (width < 1024) return 'bg-yellow-400';    // Tablet
    if (width < 1440) return 'bg-green-400';     // Laptop
    return 'bg-blue-400';                        // Desktop
  }

  useEffect(() => {
    const handleResize = () => {
      setBgColor(getColor(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`w-full bg-white sm:bg-red-400 md:bg-yellow-400 lg:bg-green-400 xl:bg-blue-400 2xl:bg-orange-400  text-white flex items-center justify-center text-xl font-bold`}>
      Window Width: {window.innerWidth}px
    </div>
  );
};

export default ResponsiveColorWidget;